export default __webpack_public_path__ + "static/media/logo_with_text.12f2a978.svg";